import { gql } from '@apollo/client'

import { MAX_INT_FOR_PAGINATION_SIZE } from 'config/constants'

export const GET_SERVICES = gql`
  query GetServices($pagination: Pagination, $input: servicesQueryInput) {
    servicesWithPagination(pagination: $pagination, input: $input) {
      total
      items {
        id
        code
        isActive
        isDeletable
        dow
        startAt
        endAt
        businessClients {
          id
          name
          businessSites {
            id
            name
          }
        }
        confirmationModalities {
          paid
          reserved
          facebook
        }
        companyLine {
          id
          name
          company {
            id
          }
        }
        itinerariesSchedule {
          id
          startAt
          endAt
          dow
          route {
            id
            stops {
              id
            }
          }
          itinerary {
            placeID
            departure {
              time
              day
            }
            arrival {
              time
              day
            }
          }
        }
        vehiclesSchedule {
          id
          vehicle {
            id
            name
            externalID
          }
          driver {
            id
            userAccount {
              id
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`

export const GET_SERVICE_V2 = gql`
  query GetService($serviceId: ID!) {
    service(input: { id: $serviceId }) {
      id
      code
      isActive
      priceCheckedAt
      hasTolls
      isPrivate
      isOnGuard
      peaks {
        id
        startAt
        endAt
      }
      businessClients {
        id
        name
        businessSites {
          id
          name
        }
      }
      companyLine {
        id
        name
        company {
          id
          name
          vertical
        }
      }
      route {
        id
        stops {
          id
          name
          timezone
        }
      }
      itinerariesSchedule {
        id
        status
        startAt
        endAt
        dow
        route {
          id
          stops {
            id
            name
            timezone
          }
        }
        itinerary {
          placeID
          timezone
          arrival {
            time
            day
          }
          departure {
            time
            day
          }
        }
        notes {
          createdAt
          text
          user {
            id
            firstName
            lastName
          }
        }
      }
      vehiclesSchedule {
        id
        startAt
        endAt
        dow
        frequency {
          value
          unit
        }
        vehicle {
          id
          name
          externalID
        }
        driver {
          id
          userAccount {
            id
            firstName
            lastName
          }
        }
      }
      startAt
      endAt
      activePeriod
      salesChannelsV2 {
        id
        name
      }
      limits {
        type
        key
        value
      }
      createdAt
      createdBy {
        username
      }
      crewUsers {
        id
        username
        firstName
        lastName
      }
      confirmationModalitiesV2 {
        name
        salesChannels {
          id
          name
        }
        exceptions {
          places {
            id
            name
          }
        }
      }
      hasSelectableSeats
      isPetFriendly
    }
  }
`

export const GET_SERVICES_BY_SEGMENTS = gql`
  query ServicesBySegments($segmentIds: [ID!]) {
    servicesWithPagination(pagination: { page: 0, size: ${MAX_INT_FOR_PAGINATION_SIZE} }, input: { segmentIDs: $segmentIds }) {
      items {
        id
        code
      }
    }
  }
`

export const GET_SERVICES_FOR_EDIT_ROUTE = gql`
  query GetServicesForEditRoute($routeId: ID) {
    servicesWithPagination(pagination: { page: 0, size: ${MAX_INT_FOR_PAGINATION_SIZE} }, input: { routeID: $routeId }) {
      items {
        id
        code
        isActive
        startAt
        endAt
        activePeriod
        priceCheckedAt
        itinerariesSchedule {
          id
          status
          startAt
          endAt
          dow
          route {
            id
            stops {
              id
              name
            }
          }
          itinerary {
            placeID
            timezone
            departure {
              time
              day
            }
            arrival {
              time
              day
            }
          }
          notes {
            createdAt
            text
            user {
              id
              firstName
              lastName
            }
          }
        }
        companyLine {
          id
          name
          company {
            id
          }
        }
      }
    }
  }
`

export const GET_SALES_CHANNELS = gql`
  query GetSalesChannels($pagination: Pagination, $input: SalesChannelsInput) {
    salesChannels(pagination: $pagination, input: $input) {
      total
      items {
        id
        name
        country {
          id
          currency {
            id
            code
          }
        }
      }
    }
  }
`

export const GET_SALES_CHANNEL = gql`
  query GetSalesChannel($input: SalesChannelInput!) {
    salesChannel(input: $input) {
      id
      name
    }
  }
`

export const GET_ROUTE_SERVICES_AUTOCOMPLETE = gql`
  query GetRouteServicesAutocomplete($input: RouteServiceSuggestionsInput!, $pagination: PaginationV2) {
    routeServiceSuggestions(input: $input, pagination: $pagination) {
      items {
        id
        code
        departureTime
      }
    }
  }
`
